import { useRouteMatch } from 'react-router-dom';
import {
  INCIDENT_EDIT_REPORT_ROUTE_PATH,
  ROUTER_ENTITY_TO_ROUTE_PATH_MAP,
  INCIDENT_VIEW_REPORT_ROUTE_PATH,
} from '../../../../constants';

type IncidentGeoEventParams = {
  geoEventId?: string;
};

export const useSelectedIncidentGeoEventId = (): number | undefined => {
  // Using `useRouteMatch()` instead of `useParams()` since we're not always inside the GeoEvent <Router>
  const match = useRouteMatch<IncidentGeoEventParams>([
    ROUTER_ENTITY_TO_ROUTE_PATH_MAP.wildfire,
    // These report routes can be rendered as nested routes inside the incident route.
    INCIDENT_VIEW_REPORT_ROUTE_PATH,
    INCIDENT_EDIT_REPORT_ROUTE_PATH,
  ]);
  const geoEventIdStr = match?.params.geoEventId;

  return geoEventIdStr ? parseInt(geoEventIdStr, 10) : undefined;
};
